module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/step-1-3d7e99570e01c6cff56932a6d37a1bac.png";